import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const CarouselItemJobDetailPage = ({
    applicationClosingDate = null,
    authority = null,
    carouselItemIndex = null,
    contractType = null,
    duration = null,
    location = null,
    locationRemote = null,
    salaryMax = null,
    salaryMin = null,
    title = null,
    url = null
}) => {
    return (
        <>
            {carouselItemIndex === 0 && (
                <div className='hidden md:block md:w-1/5 layout-grid-col-padding'/>
            )}

            <div className={`-ml-15 expand-interaction focus-within:bg-peach hover:bg-peach p-30${carouselItemIndex === 0 ? ' w-12/12 md:w-4/5' : ' w-12/12'}`}>
                <div className='pr-35'>
                    <a
                        className='flex flex-col h-full pr-50'
                        href={url}>
                        {(location && !locationRemote) && (
                            <p className='type-style-4'>
                                {location}
                            </p>
                        )}

                        {locationRemote && (
                            <p className='type-style-4'>
                                Remote
                            </p>
                        )}

                        {title && (
                            <p className='type-style-3 mt-30 md:mt-40'>
                                {title}
                            </p>
                        )}

                        {authority?.title && (
                            <p className='type-style-4 mt-20 md:mt-30'>
                                Sought by {authority.title}
                            </p>
                        )}

                        <div className='flex gap-20 mt-60'>
                            <div className='w-6/12'>
                                {contractType?.title && (
                                    <p className='type-style-4'>
                                        {contractType.title}
                                    </p>
                                )}

                                {(salaryMin || salaryMax) && (
                                    salaryMin === salaryMax ? (
                                        <p className='type-style-4'>
                                            {salaryMin && (
                                                <span>
                                                    {new Intl.NumberFormat(
                                                        'en-GB',
                                                        {
                                                            currency: 'GBP',
                                                            maximumFractionDigits: 0,
                                                            minimumFractionDigits: 0,
                                                            style: 'currency',
                                                        }
                                                    ).format(salaryMin)}
                                                </span>
                                            )}
                                        </p>
                                    ) : (
                                        <p className='type-style-4'>
                                            {salaryMin && (
                                                <span>
                                                    {new Intl.NumberFormat(
                                                        'en-GB',
                                                        {
                                                            currency: 'GBP',
                                                            maximumFractionDigits: 0,
                                                            minimumFractionDigits: 0,
                                                            style: 'currency',
                                                        }
                                                    ).format(salaryMin)}
                                                </span>
                                            )}

                                            {salaryMin && salaryMax && (
                                                <span> &ndash; </span>
                                            )}

                                            {salaryMax && (
                                                <span>
                                                    {new Intl.NumberFormat(
                                                        'en-GB',
                                                        {
                                                            currency: 'GBP',
                                                            maximumFractionDigits: 0,
                                                            minimumFractionDigits: 0,
                                                            style: 'currency',
                                                        }
                                                    ).format(salaryMax)}
                                                </span>
                                            )}
                                        </p>
                                    )
                                )}
                            </div>

                            <div className='w-6/12'>
                                {duration?.title && (
                                    <p className='type-style-4'>
                                        {duration?.title}
                                    </p>
                                )}

                                {applicationClosingDate && (
                                    <p className='type-style-4'>
                                        {new Intl.DateTimeFormat(
                                            'en-GB',
                                            {
                                                day: 'numeric',
                                                month: 'short',
                                                year: 'numeric'

                                            }).format(new Date(applicationClosingDate))}
                                    </p>
                                )}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

CarouselItemJobDetailPage.propTypes = {
    applicationClosingDate: PropTypes.string.isRequired,
    authority: PropTypes.object.isRequired,
    carouselItemIndex: PropTypes.number.isRequired,
    contractType: PropTypes.object.isRequired,
    duration: PropTypes.object.isRequired,
    location: PropTypes.string.isRequired,
    locationRemote: PropTypes.bool.isRequired,
    salaryMax: PropTypes.number.isRequired,
    salaryMin: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default CarouselItemJobDetailPage;
